import { render, staticRenderFns } from "./fooldalDesktopSkeleton.vue?vue&type=template&id=3b4ff337&"
import script from "./fooldalDesktopSkeleton.vue?vue&type=script&lang=js&"
export * from "./fooldalDesktopSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports